import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { editTestPoint } from "./UserFunctions";
import PopupModal from "./PopupModal";
import { editTestTableData } from "../actions/scenarioTestTableAction";
import PropTypes from 'prop-types';

class EditTestTableModal extends Component {
    constructor(props){
        super(props)
        this.state = {
            test_point_id: undefined,
            scenario_group_id: undefined,
            bench_id: undefined,
            bench_name: undefined,
            status: undefined,
            togglePopup: false,
            popupText: undefined
        }
        this.onBenchIdChange = this.onBenchIdChange.bind(this);
        this.onScenarioGroupIdChange = this.onScenarioGroupIdChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this);
        this.closePopupModal = this.closePopupModal.bind(this);
    }

    componentDidMount() {
        if(this.props.formData){
            this.setState( (prevState) => {
                return {
                    test_point_id: this.props.formData.test_point_id,
                    scenario_group_id: this.props.formData.scenario_group_id,
                    bench_id: this.props.formData.bench_id,
                    bench_name: this.props.formData.bench_name,
                    status: this.props.formData.status
                }
            })
        }
    }

    onBenchIdChange(e) {
        const value = e.target.value;
        this.setState( (prevState) => ({ bench_id: value }) )
    }

    onScenarioGroupIdChange(e) {
        const value = e.target.value;
        this.setState( (prevState) => ({ scenario_group_id: value }) )
    }

    onSubmit(e) {
        e.preventDefault();
        const submitValue = {
            ...this.state,
            scenario_group_name: this.props.formData.scenario_group_name,
            upload_button: this.props.formData.upload_button
        }
        console.log(submitValue)
        editTestPoint(submitValue, `${window.location.origin}/edit_test_point`).then( (response) => {
            if(response && response.status === 200) {
                this.props.dispatch(editTestTableData(submitValue));
                this.setState( (prevState) => {
                    return {
                        togglePopup: true,
                        popupText: response.data.status_message
                    }
                })
            }
        })
    }

    closePopupModal() {
        this.setState( (prevState) => {
            return {
                togglePopup: false
            }
        })
        this.props.handleCloseEditModal()
    }

    render() {
        return(
            <div>
                <Modal isOpen={this.props.editSelectedRow >=0}>
                    <ModalHeader
                        toggle={this.props.handleCloseEditModal}
                        style={{ color: "#753DFF" }}
                    >
                        Edit Test Point
                    </ModalHeader>
                    <ModalBody>
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={this.onSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="testPointId" style={{ color:"#524fa1" }} >Test Point Id</label>
                                        <input
                                            type="text"
                                            disabled={true}
                                            className="form-control"
                                            id="testPointId"
                                            placeholder="Test Point Id"
                                            value={this.state.test_point_id}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="scenarioGroupId" style={{ color:"#524fa1" }} >Scenario Group Id</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="scenarioGroupId"
                                            placeholder="Scenario Group Id"
                                            value={this.state.scenario_group_id}
                                            onChange={this.onScenarioGroupIdChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="benchId" style={{ color:"#524fa1" }} >Bench Id</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="benchId"
                                            placeholder="Bench Id"
                                            value={this.state.bench_id}
                                            onChange={this.onBenchIdChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="benchName" style={{ color:"#524fa1" }} >Bench Name</label>
                                        <input
                                            type="text"
                                            disabled={true}
                                            className="form-control"
                                            id="benchName"
                                            placeholder="Bench Name"
                                            value={this.state.bench_name}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="status" style={{ color:"#524fa1" }} >Status</label>
                                        <input
                                            type="text"
                                            disabled={true}
                                            className="form-control"
                                            id="status"
                                            placeholder="Status"
                                            value={this.state.status}
                                        />
                                    </div>
                                    <button type="submit" className="btn">Submit</button>
                                </form>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn btn-secondary" onClick={this.props.handleCloseEditModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <div>
                    {this.state.togglePopup ? <PopupModal text={this.state.popupText} closePopup={this.closePopupModal}/>: undefined}
                </div>
            </div>
        )
    }
}
EditTestTableModal.propTypes={
formData:PropTypes.string,
dispatch:PropTypes.string,
handleCloseEditModal:PropTypes.string,
editSelectedRow:PropTypes.string,
//navigateHome:PropTypes.string,
}
EditTestTableModal.defaultProps= {
formData:[],
dispatch:[],
handleCloseEditModal:[],
editSelectedRow:[],
//navigateHome:[],
}
// componentDidMount() {
//     if(this.props.formData){
//         this.setState( (prevState) => {
//             return {
//                 test_point_id: this.props.formData.test_point_id,
//                 scenario_group_id: this.props.formData.scenario_group_id,
//                 bench_id: this.props.formData.bench_id,
//                 bench_name: this.props.formData.bench_name,
//                 status: this.props.formData.status
//             }
//         })
//     }
// }

// onBenchIdChange(e) {
//     const value = e.target.value;
//     this.setState( (prevState) => ({ bench_id: value }) )
// }

// onScenarioGroupIdChange(e) {
//     const value = e.target.value;
//     this.setState( (prevState) => ({ scenario_group_id: value }) )
// }

// onSubmit(e) {
//     e.preventDefault();
//     const submitValue = {
//         ...this.state,
//         scenario_group_name: this.props.formData.scenario_group_name,
//         upload_button: this.props.formData.upload_button
//     }
//     console.log(submitValue)
//     editTestPoint(submitValue, `${window.location.origin}/edit_test_point`).then( (response) => {
//         if(response && response.status === 200) {
//             this.props.dispatch(editTestTableData(submitValue));
//             this.setState( (prevState) => {
//                 return {
//                     togglePopup: true,
//                     popupText: response.data.status_message
//                 }
//             })
//         }
//     })
// }

// closePopupModal() {
//     this.setState( (prevState) => {
//         return {
//             togglePopup: false
//         }
//     })
//     this.props.handleCloseEditModal()
// }

export default connect()(EditTestTableModal);